import { useMocks } from '../../shared/env';
import type { NotificationsGateway } from './NotificationsGateway';
import { HttpNotificationsGateway } from './HttpNotificationsGateway';
import { MockNotificationsGateway } from './MockNotificationsGateway';

export const notificationsGateway: NotificationsGateway = useMocks ? new MockNotificationsGateway() : new HttpNotificationsGateway();
export type { NotificationsGateway } from './NotificationsGateway';
export * from './types';
